import { combineEpics, ofType } from "redux-observable"
import { from, map, mergeMap, switchMap, withLatestFrom } from "rxjs"
import { setEquipmentsAboveESP, setEquipmentsBelowESP, setSchematicNotification } from "../../../store/calculation/calculation-output/schematicSlice"
import { fetchEquipmentsForAboveESP, fetchEquipmentsForBelowESP } from "../../../services/calculations/calculation-output/schematic.service"

const fetchEquipmentsforAboveESP = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("schematic/fetchEquipmentsForAboveESP", "tubing/setTubingID"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const { tubing } = state;
            const payload = {
                series: tubing?.tab1Input?.tubingOD,
                catalogFilter: tubing?.tab1Input?.catalogType
            }
            return from(fetchEquipmentsForAboveESP(payload)).pipe(
                map(data => {
                    return setEquipmentsAboveESP(data);
                })
            )
        })
    )
};


const fetchEquipmentsforBelowESP = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("schematic/fetchEquipmentsForBelowESP"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const { tubing } = state;
            const catalogFilter = tubing?.tab1Input?.catalogType;
            return from(fetchEquipmentsForBelowESP(catalogFilter)).pipe(
                mergeMap(data => {
                    if (data?.length === 0) {
                        setSchematicNotification({
                            show: true,
                            message: "There are no co-related Equipments for Below ESP",
                            type: "info"
                        });
                    }
                    return [
                        setSchematicNotification({
                            show: false,
                            message: "",
                            type: ""
                        }),
                        setEquipmentsBelowESP(data)
                    ];
                })
            )
        })
    )
};

export const schematicEpic = combineEpics(fetchEquipmentsforAboveESP, fetchEquipmentsforBelowESP);